import { Button, Form, FormControlProps } from 'react-bootstrap'
import { EmailConfirmationStyled, EmailInput } from './EmailConfirmation.styled'
import { FormInputStyled } from './FormInput.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons'
import { theme } from 'core/skins/BMW/theme'
import { FormInput } from 'components/Forms'
import { FieldArray, useFormikContext } from 'formik'
import { IMyProfile } from 'types/userTypes'

interface IEmailProps extends FormControlProps {
  label?: string
  type?: string
  name: string
}

export const EmailConfirmation = ({ label, type, name, ...props }: IEmailProps) => {
  const formik = useFormikContext<IMyProfile>()

  return (
    <EmailConfirmationStyled>
      <FieldArray
        name={name}
        render={(arrayHelper) => (
          <>
            <FormInputStyled>
              <Form.Label className="label">{label}</Form.Label>
              <br />
              <FontAwesomeIcon
                className="add-icon"
                icon={faPlusCircle}
                color={theme.colors.primary}
                onClick={() => arrayHelper.insert(formik.values?.[name]?.length, '')}
              />
            </FormInputStyled>
            {formik.values?.[name]?.map((email, index) => (
              <EmailInput>
                <FormInput
                  key={`${name}${index}`}
                  name={`${name}.${index}`}
                  type="text"
                  label={`EMAIL ADDRESS ${index + 1}`}
                  className="col-sm-6 email-input"
                  id={index.toString()}
                  value={email}
                  onChange={(e) => {
                    formik.setFieldValue(`${name}.${index}`, e.target.value.slice(0, 50))
                  }}
                  onBlur={formik.handleBlur}
                  isInvalid={!!formik.errors?.[name]?.[index] && formik?.touched?.[name]?.[index]}
                  error={formik?.errors?.[name]?.[index]}
                  autoComplete="nope"
                  data-lpignore="true"
                  maxLength={50}
                />
                <FontAwesomeIcon
                  className="remove-icon"
                  icon={faMinusCircle}
                  color={theme.colors.primary}
                  id={index.toString()}
                  onClick={() => {
                    arrayHelper.remove(index)
                  }}
                />
              </EmailInput>
            ))}
          </>
        )}
      />
    </EmailConfirmationStyled>
  )
}
